<script setup lang="ts">
import type { ShopSelectItem } from "~/models/Shop"

const props = defineProps<{
    menuItem: {
        name: string
        route: string
        page: string
    }
}>()

const router = useRouter()
const openDropdown = ref(false)
const shopListStore = useShopListStore()
const loadingShop = computed(() => {
    return shopListStore.loading
})
const route = useRoute()

// i18n for translations
const { t: $t } = useI18n()

const toggleOpenDropdown = () => {
    if (loadingShop.value) return
    openDropdown.value = !openDropdown.value
}

const goToStore = (shop?: ShopSelectItem) => {
    if (shop) {
        shopListStore.fetchCurrentShop(shop)
    } else {
        shopListStore.clearCurrentShop()
    }
    return shop
        ? router.push({ path: `/store/${shop.slug}` })
        : router.push({ path: "/store" })
}
</script>

<template>
    <q-btn-dropdown
        class="tw-capitalize custom-menu tw-font-titilium tw-rounded-full tw-h-10 tw-min-w-max sm:tw-min-w-[140px] tw-text-xs sm:tw-text-base tw-font-bold !tw-border-0 !tw-w-max md:tw-bg-secondary hover:md:tw-bg-secondary-800 !tw-px-4 sm:!tw-py-2 !tw-py-0 tw-text-secondary md:tw-text-white"
        flat
        dropdown-icon="none"
    >
        <template #label>
            <div
                class="tw-flex tw-items-center tw-w-full tw-justify-between tw-text-inherit tw-gap-1"
                @click="toggleOpenDropdown"
            >
                <q-icon name="local_mall" size="16px" />
                <template v-if="shopListStore.currentShop">
                    <q-item-label class="tw-px-auto tw-font-titilium">{{
                        shopListStore.currentShop.name
                    }}</q-item-label>
                </template>
                <template v-else>
                    <q-item-label class="tw-px-auto tw-font-titilium">{{
                        menuItem.name
                    }}</q-item-label>
                </template>
                <div class="tw-flex tw-items-center tw-gap-1">
                    <div
                        v-if="loadingShop"
                        class="tw-cursor-pointer tw-relative all-pointer-events"
                    >
                        <q-spinner-ios
                            size="20px"
                            class="tw-text-secondary md:tw-text-white"
                        />
                        <q-tooltip
                            class="tw-text-white tw-bg-secondary tw-shadow-4"
                            anchor="top middle"
                            self="bottom middle"
                            :offset="[10, 10]"
                        >
                            Cargando {{ $t("fields.stores") }}
                        </q-tooltip>
                    </div>
                    <template v-else>
                        <q-icon
                            v-if="!openDropdown"
                            name="keyboard_arrow_down"
                            size="20px"
                        />
                        <q-icon v-else name="keyboard_arrow_up" size="20px" />
                    </template>
                </div>
            </div>
        </template>
        <q-list>
            <q-item
                class="!tw-shadow-none !tw-bg-transparent"
                clickable
                v-close-popup
                @click="goToStore()"
            >
                <q-item-section
                    class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-2"
                >
                    <q-item-label class="!tw-text-sm lg:!tw-text-base"
                        >Todas</q-item-label
                    >
                </q-item-section>
            </q-item>
            <q-item
                class="!tw-shadow-none !tw-bg-transparent"
                clickable
                v-close-popup
                v-for="(shop, i) in shopListStore.shopList"
                :key="i"
                @click="goToStore(shop)"
            >
                <q-item-section
                    class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-2"
                >
                    <q-item-label class="!tw-text-sm lg:!tw-text-base">{{
                        shop.name
                    }}</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </q-btn-dropdown>
</template>
